var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { StreamTypes, } from "../../../AuviousApi";
import { uuid } from "../../../Common";
import { updateConferenceMetadata } from "../sagas";
import { joinedConferenceMetadataByKeySelector } from "../selectors";
import { ConferenceStreamType } from "../model";
import { updateStreamMetadata, updateStreamVideoBitrate } from "./sagas";
import log from "../../../log";
/**
 * Wrappers around server requests and the data needed
 */
export class PublishStream {
    /**
     * Initialize objects used throughout publishstream's lifecycle
     * @param csi - the context conference
     * @param action - the action that initiated all
     */
    constructor(csi, action) {
        this.csi = csi;
        this.action = action;
        this.muted = {
            audio: false,
            video: false,
        };
        this.enabled = {
            audio: false,
            video: false,
        };
        this.answerReceived = false;
        this.conferenceId = csi.conference.name;
        this.userId = csi.getParentContext().identity();
        this.userEndpointId = csi.getParentContext().endpoint();
        this.streamId = action.payload.streamId;
        const options = csi.publishTasks[this.streamId].options;
        this.streamType =
            options.type === StreamTypes.VIDEO
                ? ConferenceStreamType.MIC_AND_CAM
                : options.type;
        this.enabled.audio = [
            ConferenceStreamType.MIC,
            ConferenceStreamType.MIC_AND_CAM,
        ].includes(this.streamType);
        this.enabled.video = [
            ConferenceStreamType.SCREEN,
            ConferenceStreamType.MIC_AND_CAM,
            ConferenceStreamType.CAM,
        ].includes(this.streamType);
        // init IStream
        this.id = this.streamId;
        this.mediaStream = options.mediaStream;
        this.type = options.type;
        this.originator = {
            username: this.userId,
            endpoint: this.userEndpointId,
        };
        log.debug("options are", this.csi.publishTasks[this.id].options);
        this.body = {
            conferenceId: this.conferenceId,
            userEndpointId: this.csi.getParentContext().endpoint(),
            streamId: this.streamId,
            sdpOffer: null,
            // @ts-expect-error
            conferenceStreamType: this.streamType.toUpperCase(),
            metadata: this.csi.publishTasks[this.id].options.metadata,
            videoBitrate: this.csi.publishTasks[this.id].options.videoBitrate,
        };
    }
    updateVideoBitrate(bitrate) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.csi
                .getParentContext()
                .runSaga(updateStreamVideoBitrate, this, bitrate)
                .toPromise();
        });
    }
    updateMetadata(metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.csi
                .getParentContext()
                .runSaga(updateStreamMetadata, this, metadata)
                .toPromise();
        });
    }
    getMetadata() {
        return this.body.metadata;
    }
    setRtc(r) {
        this.rtc = r;
    }
    isMuted(kind) {
        // negated conditional
        return !this.enabled[kind] || this.muted[kind];
    }
    syncMuteState(kind) {
        const metadata = joinedConferenceMetadataByKeySelector(this.csi.getParentContext().getStore().getState(), this.csi.conference.name, "TRACK_MUTED/" + kind + "/" + this.body.streamId);
        const change = metadata ? JSON.parse(metadata[0].value) : false;
        this.setMuteState(kind, change);
    }
    /**
     * Changes state
     * @return If state was changed
     */
    setMuteState(kind, enabled) {
        if (this.isMuted(kind) === enabled) {
            return false;
        }
        this.muted[kind] = enabled;
        return true;
    }
    mute(kind) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.setMuteState(kind, true);
            (_b = (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.pc) === null || _b === void 0 ? void 0 : _b.getSenders().filter((sender) => sender.track && sender.track.kind === kind).forEach((sender) => {
                sender.track.enabled = false;
            });
            yield this.csi
                .getParentContext()
                .runSaga(updateConferenceMetadata, this.csi, "SET", "TRACK_MUTED/" + kind + "/" + this.body.streamId, true)
                .toPromise();
        });
    }
    unmute(kind, track) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.setMuteState(kind, false);
            // no sender? no unmute
            const sender = (_b = (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.pc) === null || _b === void 0 ? void 0 : _b.getSenders().find((s) => s.track && s.track.kind === kind);
            if (sender) {
                if (track) {
                    track.enabled = !this.csi.isOnHold();
                    // add new, make sure mediastreams are the same
                    this.rtc.mediaReplaceTrack(track, this.rtc.localMediaStream);
                    this.mediaStream = this.rtc.localMediaStream;
                    sender.replaceTrack(track);
                }
                else {
                    sender.track.enabled = !this.csi.isOnHold();
                }
            }
            yield this.csi
                .getParentContext()
                .runSaga(updateConferenceMetadata, this.csi, "REMOVE", "TRACK_MUTED/" + kind + "/" + this.body.streamId, false)
                .toPromise();
        });
    }
    replace(track, send) {
        return __awaiter(this, void 0, void 0, function* () {
            const sender = this.rtc.pc.getSenders().find((s) => s.track === track);
            if (sender && send) {
                yield sender.replaceTrack(send);
                this.rtc.mediaReplaceTrack(send, this.rtc.localMediaStream);
            }
        });
    }
    /**
     * calls rest api publishStream
     */
    *requestAnswer(sdpOffer) {
        this.body.sdpOffer = sdpOffer;
        this.body.streamId = uuid();
        this.response = yield this.csi
            .getConferenceResource()
            .create(this.body, { urlPostfix: "publishStream" });
        this.answerReceived = true;
    }
    /**
     * calls updateStreamMetadata
     */
    *updateStreamMetadata(metadata) {
        this.body.metadata = metadata;
        yield this.csi.getConferenceResource().create({
            conferenceId: this.conferenceId,
            userEndpointId: this.userEndpointId,
            streamId: this.body.streamId,
            newMetadata: this.body.metadata,
        }, { urlPostfix: "updateStreamMetadata" });
    }
    /**
     * calls updateStreamVideoBitrate
     */
    *updateStreamVideoBitrate(bitrate) {
        this.body.videoBitrate = bitrate;
        yield this.csi.getConferenceResource().create({
            conferenceId: this.conferenceId,
            userEndpointId: this.userEndpointId,
            streamId: this.body.streamId,
            videoBitrate: this.body.videoBitrate,
        }, { urlPostfix: "updatePublishedStreamBitrate" });
    }
    /**
     * calls unpublishStream and ignores any failure
     */
    *stopStream() {
        const _a = this.body, { sdpOffer, metadata } = _a, data = __rest(_a, ["sdpOffer", "metadata"]);
        try {
            if (this.answerReceived) {
                yield this.csi
                    .getConferenceResource()
                    .create(data, { urlPostfix: "unpublishStream" });
                this.answerReceived = false;
            }
        }
        catch (error) {
            log.error("unpublishStream conference request failed with ", error);
        }
    }
    /**
     * calls addPublishStreamIceCandidates and ignores any failure
     */
    *addCandidateRequest(iceCandidates) {
        const _a = this.body, { sdpOffer, metadata } = _a, data = __rest(_a, ["sdpOffer", "metadata"]);
        try {
            yield this.csi.getConferenceResource().create(Object.assign(Object.assign({}, data), { iceCandidates }), { urlPostfix: "addPublishStreamIceCandidates" });
        }
        catch (error) {
            log.error("addPublishStreamIceCandidates conference request failed with ", error);
        }
    }
}
